import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useApp } from './context/AppContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/public/Home';
import Products from './pages/public/Products';
import About from './pages/public/About';
import Contact from './pages/public/Contact';
import IncomePlan from './pages/public/IncomePlan';
import Login from './pages/public/Login';
import Register from './pages/public/Register';
import LegalViewer from './pages/public/LegalViewer';
import LegalCertificates from './pages/public/LegalCertificates';
const MemberDashboard = React.lazy(() => import('./pages/member/Dashboard'));
const AdminDashboard = React.lazy(() => import('./pages/admin/Dashboard'));
import { AppProvider } from './context/AppContext';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

function AppContent() {
    const { adminUser, memberUser } = useApp();

    return (
        <Router>
            <div className="bg-gray-50 min-h-screen font-outfit flex flex-col w-full">
                <Navbar />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/income-plan" element={<IncomePlan />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/privacy" element={<LegalViewer docId="privacy" />} />
                        <Route path="/terms" element={<LegalViewer docId="terms" />} />
                        <Route path="/refund" element={<LegalViewer docId="refund" />} />
                        <Route path="/disclaimer" element={<LegalViewer docId="disclaimer" />} />
                        <Route path="/legal-certificates" element={<LegalCertificates />} />
                        <Route path="/member/*" element={
                            <ProtectedRoute requiredRole="member">
                                <ErrorBoundary>
                                    <React.Suspense fallback={<div className="flex h-screen items-center justify-center">Loading Member Panel...</div>}>
                                        <MemberDashboard />
                                    </React.Suspense>
                                </ErrorBoundary>
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/*" element={
                            <ProtectedRoute requiredRole="admin">
                                <ErrorBoundary>
                                    <React.Suspense fallback={<div className="flex h-screen items-center justify-center">Loading Admin Panel...</div>}>
                                        <AdminDashboard />
                                    </React.Suspense>
                                </ErrorBoundary>
                            </ProtectedRoute>
                        } />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

function App() {
    return (
        <AppProvider>
            <ErrorBoundary>
                <AppContent />
            </ErrorBoundary>
        </AppProvider>
    );
}

export default App;
